import { FC } from "react";
import Grid from "@mui/material/Grid";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import Invoice from '../../components/Invoice/Invoice';
import { Box, Card } from "@mui/material";

interface InvoiceFormProps {
  type: string;
}

// Create/edit Invoice page
const InvoiceForm: FC<InvoiceFormProps> = ({type}) => {
  return (
    <>
      {/* <BreadCrumb /> */}
      {/* <Grid rowSpacing="36" columnSpacing="22" container> */}
        {/* <Grid item xs={12} md={12} lg={12}> */}
          <Invoice type={type} />
        {/* </Grid> */}
      {/* </Grid> */}
    </>
  );
};

export default InvoiceForm;
